<template>
  <div class="page">
    <div class="search-wrap">
      <van-search
        v-model="value"
        placeholder="输入标题/大咖搜索"
        @search="onSearch"
        @input="onSearch"
      >
      </van-search>
    </div>
    <div class="content-wrap">
      <van-list
        v-model="loading"
        :finished="pageEnd"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <CourseBagItem
          v-for="(item, index) in courseList"
          :key="index"
          :couponNo="couponNo"
          :CourseBagItemData="item"
        ></CourseBagItem>
      </van-list>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs } from '@vue/composition-api'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { List, Search } from 'vant'
import CourseBagItem from '../../components/CourseBagItem/CourseBagItem.vue'
import api from '../../api/api'
import { appInfo } from '@em/ym'
dayjs.extend(isBetween)

export default {
  name: 'UnlockCourse',
  components: {
    CourseBagItem,
    'van-search': Search,
    'van-list': List
  },
  setup() {
    const couponNo = appInfo.getParam('couponNo')

    const state = reactive({
      viewState: '',
      courseList: [],
      value: '',
      loading: false,
      pageEnd: false
    })

    async function lookCourseListData(isRest) {
      if (isRest) {
        state.viewState = ''
        state.pageEnd = false
        state.courseList = []
      }
      state.loading = true
      const { detail, result } = await api.course.lookCourseList(
        {
          type: 0,
          direction: state.viewState ? 2 : 0,
          keyword: state.value
        },
        state.viewState
      )
      if (result.code === 0) {
        if (isRest) {
          state.courseList = detail.list
        } else {
          state.courseList = state.courseList.concat(detail.list)
        }
        state.pageEnd = detail.end
        state.viewState = result.viewState
        state.loading = false
      }
    }

    function onSearch() {
      console.log('onSearch', state.value)
      lookCourseListData(true)
    }
    function onLoad() {
      lookCourseListData()
    }

    return {
      ...toRefs(state),
      onSearch,
      dayjs,
      onLoad,
      couponNo
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .search-wrap {
    flex: none;
    .van-search {
      padding: 10px 30px;
      border-radius: 4px;
      ::v-deep {
        .van-search__content {
          border-radius: 40px;
        }
      }
    }
  }
  .content-wrap {
    flex: auto;
    overflow-y: auto;
    padding: 0 30px;
    margin-top: 20px;
  }
}
</style>
